import { render, staticRenderFns } from "./TrashBasket.vue?vue&type=template&id=6866a2d3&scoped=true"
import script from "./TrashBasket.vue?vue&type=script&lang=js"
export * from "./TrashBasket.vue?vue&type=script&lang=js"
import style0 from "./TrashBasket.vue?vue&type=style&index=0&id=6866a2d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6866a2d3",
  null
  
)

export default component.exports